module.exports = __webpack_public_path__ + "img/3-draw.db742251.png";